module.exports = (object, pathToValue, blockedValues) => {
  if (!object) return false;
  let exists = pathToValue.split(".").reduce((prev, curr) => {
    return prev ? prev[curr] : null;
  }, object);

  if (exists != undefined) {
    return blockedValues != undefined && blockedValues.includes(exists)
      ? false
      : exists.toString().length > 0 && exists != "";
  } else {
    return false;
  }
};



// WEBPACK FOOTER //
// ./src/Helpers/validateData.js